import { render } from "./Jugendliche.vue?vue&type=template&id=6e8fe1d2"
import script from "./Jugendliche.vue?vue&type=script&lang=js"
export * from "./Jugendliche.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__